import { Box, Dialog, Link } from "@mui/material";
import { toast } from "react-toastify";
import { useRecoilState } from "recoil";
import { HTTP_RESPONSE_CODE } from "../../common/const";
import { useDeveloperContext } from "../../hook/useDeveloperContext";
import { apiKeyApi } from "../../openApi";
import { Apikey } from "../../openApi/api";
import { ThemeLight } from "../../state/ThemeLight";

type Props = {
  open: boolean;
  handleOpen: (open: boolean) => void;
  apiKey?: Apikey;
  handleRefresh: () => void;
};

export const RemoveAPIKeyModal = ({
  open,
  handleOpen,
  apiKey,
  handleRefresh,
}: Props) => {
  const { userID, sessionKey, handleSessionKey } = useDeveloperContext();

  const [themeLight] = useRecoilState(ThemeLight);

  const handleRemove = () => {
    apiKeyApi
      .removeKey(userID.toString(), {
        id: apiKey?.id!,
        accessToken: sessionKey!,
      })
      .then((res) => {
        if (res) {
          toast.success("API key has been removed successfully.", {
            theme: themeLight ? "light" : "dark",
          });
          handleRefresh();
          handleOpen(false);
        } else {
          toast.error("Removing api key has been failed.", {
            theme: themeLight ? "light" : "dark",
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          if (
            err.response.data.statusCode === HTTP_RESPONSE_CODE.UNAUTHORIZED
          ) {
            toast.error("Session key is expired", {
              theme: themeLight ? "light" : "dark",
            });
            handleSessionKey("");
          } else {
            toast.error(err.response.data.message, {
              theme: themeLight ? "light" : "dark",
            });
          }
        } else {
          toast.error(err.message, { theme: themeLight ? "light" : "dark" });
        }
      });
  };

  return (
    <Dialog open={open} onClose={() => handleOpen(false)} fullWidth>
      <Box
        className="modal modal-content"
        sx={{ borderRadius: "5px !important" }}
      >
        <Box className="modal-header">
          <h5 className="modal-title" id="myModaldeleteLabel">
            Confirmation Required
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => handleOpen(false)}
          ></button>
        </Box>
        <Box className="modal-body">
          <p>
            Are you sure you wish to remove the APIKey{" "}
            <span id="spanApiKey" className="text-muted">
              {apiKey?.apiKey ?? ""}
            </span>{" "}
            ?
          </p>
        </Box>
        <Box className="modal-footer bg-light">
          <Link
            data-bs-dismiss="modal"
            className="btn btn-ghost-white"
            href="#"
            onClick={() => handleOpen(false)}
          >
            Cancel
          </Link>
          <input
            type="submit"
            name="ctl00$ContentPlaceHolder1$btnContinueRemove"
            value="Remove"
            id="ContentPlaceHolder1_btnContinueRemove"
            className="btn btn-primary"
            onClick={handleRemove}
          />
        </Box>
      </Box>
    </Dialog>
  );
};
